import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import IntakeFormRender from './IntakeFormRender';
import useLocalStorage from '../utils/hooks/useLocalStorage';
import { SearchStack } from '../utils/SearchStack';
import GA from '../utils/GoogleAnalytics';

const IntakeForm = props => {
  const setValues = useLocalStorage('formValues', {})[1];
  const { onError, queryValues } = props;

  return (
    <Form
      onSubmit={formData => {
        setValues(formData);
        if (GA.trackingEnabled) {
          GA.client.event({
            category: 'User',
            action: 'Intake search',
            label: `${formData.skill}/${formData.topics}`
          });
        }
        const stack = new SearchStack();
        stack.push({ skill: formData.skill, topics: formData.topics }, { data: [], totalCount: 0 });
      }}
      initialValues={{ email: queryValues.email }}
      render={formProps => <IntakeFormRender {...formProps} onError={onError} />}
    />
  );
};

IntakeForm.propTypes = {
  onError: PropTypes.func.isRequired,
  queryValues: PropTypes.shape({
    email: PropTypes.string
  }).isRequired
};

export default IntakeForm;
